(function(){"use strict";}());

angular.module("app")
    .directive("themeSelectionView", ["AppService", "$timeout","$rootScope", function(AppService, $timeout,$rootScope){

        return {
            restrict: "A",
            replace: false,
            templateUrl: "views/theme-selection.html",
            link: function($scope, element, attributes){
                var trace = angular.trace;
                $scope.title = "Choose your adventure";

                $scope.$watch("ready",initialize);
                $rootScope.resetMap = true;

                $scope.nextPage = function(){
            		var page = $scope[$scope.stage.advanceToScreen];
            		$scope.setCurrentPage(page);
                };


                $scope.openComicPanels = function(theme){
                    //TODO: Open Comic Panel logic for referred theme goes here
                };

                $scope.selectAdventure = function(adventure){
                    adventure.started = true;

                    $rootScope.requestAudio("Open_Envelope");

                    $timeout(function(){
                        $scope.setCurrentAdventure(adventure.id);
                        if(__STANDALONE__){
                            for(var i = 0, count = $scope.currentAdventure.locations.length; i < count; i++){
                                var location = $scope.currentAdventure.locations[i];
                                if(!location["mini-game"]) continue;
                                if(location["mini-game"].type === "qa"){
                                    location.correct = true;
                                    location["mini-game"].intro = "mini-qa-standalone";
                                    $scope.setCurrentLocation(location);
                                    $scope.setCurrentPage($scope.PAGE_MINIGAME_PRE);
                                    break;
                                }
                            }
                        }
                        else{
                            $scope.setCurrentPage($scope.PAGE_MAP);
                        }
                        
                    },1000);
                    
                    var evt = {
                        eventCategory: "GRTT: Adventure Selection",
                        eventLabel: "GRTT: " + adventure.title
                    };
                    gtag("event", "GRTT: navigate", evt);
                };

                function initialize(value){
                    if(!value) return;

                    $scope.themes = AppService.adventureListing.concat();//stage.themes;
                    $scope.row1 = $scope.themes.slice(0,3);
                    $scope.row2 = $scope.themes.slice(3);
                }

            }
        };

    }]);
